import React, { Fragment } from "react";
import LazyLoad from 'react-lazyload';

import {
    Column,
    ColumnContainer,
    Divider,
    TitleContainer,
    SectionTitle,
    Paragraph,
} from "@beacharound/beacharound-ui";

export default function AccessibilitiesList({ accessibilities, title }) {

    const positiveAccessibilities = accessibilities?.filter(accessibility => accessibility.value)

    if (!positiveAccessibilities || positiveAccessibilities.length <= 0) {
        return <Fragment></Fragment>
    }

    return (
        <LazyLoad height={200}>
            <ColumnContainer noMargin>
                <Column>
                    <TitleContainer>
                        <SectionTitle text={title || "Accessibilità"} />
                        {positiveAccessibilities.map(({ accessibility }, index) => (
                            <Paragraph key={index} text={`• ${accessibility?.name}`} />
                        ))}
                    </TitleContainer>
                    <Divider />
                </Column>
            </ColumnContainer>
        </LazyLoad>
    )
}